<template lang="pug">
header-scroll-links(
  :links="currentLinksOnPage"
  :observer-ids="observerIds"
)
  template(#inner-append)
    template(v-if="($user.isMember || !$user.isAuthenticated) && event && event.options && !isGlobalEventView && event.canRequestByNominationOptions")
      app-button(
        :class="{ 'ml-auto': !$vuetify.breakpoint.smAndDown }"
        :disabled="event.isClosed"
        rounded
        @click="onRegisterClick"
      ) {{ event.registerTitle }}
    portal(
      :to="`${constants.DIALOG_PORTAL_KEY}.content`"
      v-slot="{ close }"
    )
      .d-flex.align-center.justify-center
        simple-login-form(
          no-redirect
          @success="close"
        )
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderScrollLinks from './components/HeaderScrollLinks.vue';
import { uniformDistribution } from '@/modules/UserEventLanding/functions';
import SimpleLoginForm from '@/modules/UIDesign/Auth/components/Forms/SimpleLoginForm.vue';

const DIALOG_PORTAL_KEY = 'login-dialog';

export default {
  name: 'EventLandingHeaderContent',
  components: {
    HeaderScrollLinks,
    SimpleLoginForm,
  },
  props: {
    event: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isFixedMenu: false,
    };
  },
  computed: {
    ...mapGetters({
      linksList: 'redesignHeaderLinks/getLinks',
      observerIds: 'redesignHeaderLinks/getObserverIds',
    }),
    constants() {
      return {
        DIALOG_PORTAL_KEY,
      };
    },
    isGlobalEventView() {
      return String(this.$route?.query?.global) === 'true';
    },
    // REFACTOR
    currentLinksOnPage() {
      const LINKS_ON_PAGE = 4;
      return uniformDistribution((this.linksList || []).map((item) => {
        if (item.id === 'experts') {
          return {
            ...item,
            name: 'Эксперты',
          };
        }

        return item;
      }), LINKS_ON_PAGE);
    },
  },
  watch: {},
  methods: {
    openLoginModal() {
      this.$dialogs.portal({
        attrs: {
          'max-width': 640,
          inputValue: DIALOG_PORTAL_KEY,
          title: 'Вход в систему',
          'card-attrs': {
            class: 'redesign ui-design',
          },
          hideActions: true,
        },
      });
    },
    onRegisterClick() {
      if (this.$user.isAuthenticated) {
        this.$router.push({ name: 'event-register-redesign', params: { new: true } });
        return;
      }

      this.openLoginModal();
    },
  },
};
</script>
